/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as AcceptInvitationRouteImport } from './routes/accept-invitation'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as AuthenticatedRoadmapIndexRouteImport } from './routes/_authenticated/roadmap/index'
import { Route as AuthenticatedProfileIndexRouteImport } from './routes/_authenticated/profile/index'
import { Route as AuthenticatedOrganizationsIndexRouteImport } from './routes/_authenticated/organizations/index'
import { Route as AuthenticatedKnowledgeBaseIndexRouteImport } from './routes/_authenticated/knowledge-base/index'
import { Route as AuthenticatedIdeasIndexRouteImport } from './routes/_authenticated/ideas/index'
import { Route as AuthenticatedCampaignsIndexRouteImport } from './routes/_authenticated/campaigns/index'
import { Route as FeedbacksCampaignTypeCampaignIdRouteImport } from './routes/feedbacks/$campaignType.$campaignId'
import { Route as AuthenticatedRoadmapIdRouteImport } from './routes/_authenticated/roadmap/$id'
import { Route as AuthenticatedOrganizationsIdRouteImport } from './routes/_authenticated/organizations/$id'
import { Route as AuthenticatedCampaignsCampaignIdRouteImport } from './routes/_authenticated/campaigns/$campaignId'

const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInvitationRoute = AcceptInvitationRouteImport.update({
  id: '/accept-invitation',
  path: '/accept-invitation',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoadmapIndexRoute =
  AuthenticatedRoadmapIndexRouteImport.update({
    id: '/roadmap/',
    path: '/roadmap/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileIndexRoute =
  AuthenticatedProfileIndexRouteImport.update({
    id: '/profile/',
    path: '/profile/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrganizationsIndexRoute =
  AuthenticatedOrganizationsIndexRouteImport.update({
    id: '/organizations/',
    path: '/organizations/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedKnowledgeBaseIndexRoute =
  AuthenticatedKnowledgeBaseIndexRouteImport.update({
    id: '/knowledge-base/',
    path: '/knowledge-base/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIdeasIndexRoute = AuthenticatedIdeasIndexRouteImport.update({
  id: '/ideas/',
  path: '/ideas/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCampaignsIndexRoute =
  AuthenticatedCampaignsIndexRouteImport.update({
    id: '/campaigns/',
    path: '/campaigns/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const FeedbacksCampaignTypeCampaignIdRoute =
  FeedbacksCampaignTypeCampaignIdRouteImport.update({
    id: '/feedbacks/$campaignType/$campaignId',
    path: '/feedbacks/$campaignType/$campaignId',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthenticatedRoadmapIdRoute = AuthenticatedRoadmapIdRouteImport.update({
  id: '/roadmap/$id',
  path: '/roadmap/$id',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedOrganizationsIdRoute =
  AuthenticatedOrganizationsIdRouteImport.update({
    id: '/organizations/$id',
    path: '/organizations/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCampaignsCampaignIdRoute =
  AuthenticatedCampaignsCampaignIdRouteImport.update({
    id: '/campaigns/$campaignId',
    path: '/campaigns/$campaignId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/accept-invitation': typeof AcceptInvitationRoute
  '/onboarding': typeof OnboardingRoute
  '/register': typeof RegisterRoute
  '/login': typeof LoginIndexRoute
  '/campaigns/$campaignId': typeof AuthenticatedCampaignsCampaignIdRoute
  '/organizations/$id': typeof AuthenticatedOrganizationsIdRoute
  '/roadmap/$id': typeof AuthenticatedRoadmapIdRoute
  '/feedbacks/$campaignType/$campaignId': typeof FeedbacksCampaignTypeCampaignIdRoute
  '/campaigns': typeof AuthenticatedCampaignsIndexRoute
  '/ideas': typeof AuthenticatedIdeasIndexRoute
  '/knowledge-base': typeof AuthenticatedKnowledgeBaseIndexRoute
  '/organizations': typeof AuthenticatedOrganizationsIndexRoute
  '/profile': typeof AuthenticatedProfileIndexRoute
  '/roadmap': typeof AuthenticatedRoadmapIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/accept-invitation': typeof AcceptInvitationRoute
  '/onboarding': typeof OnboardingRoute
  '/register': typeof RegisterRoute
  '/login': typeof LoginIndexRoute
  '/campaigns/$campaignId': typeof AuthenticatedCampaignsCampaignIdRoute
  '/organizations/$id': typeof AuthenticatedOrganizationsIdRoute
  '/roadmap/$id': typeof AuthenticatedRoadmapIdRoute
  '/feedbacks/$campaignType/$campaignId': typeof FeedbacksCampaignTypeCampaignIdRoute
  '/campaigns': typeof AuthenticatedCampaignsIndexRoute
  '/ideas': typeof AuthenticatedIdeasIndexRoute
  '/knowledge-base': typeof AuthenticatedKnowledgeBaseIndexRoute
  '/organizations': typeof AuthenticatedOrganizationsIndexRoute
  '/profile': typeof AuthenticatedProfileIndexRoute
  '/roadmap': typeof AuthenticatedRoadmapIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/accept-invitation': typeof AcceptInvitationRoute
  '/onboarding': typeof OnboardingRoute
  '/register': typeof RegisterRoute
  '/login/': typeof LoginIndexRoute
  '/_authenticated/campaigns/$campaignId': typeof AuthenticatedCampaignsCampaignIdRoute
  '/_authenticated/organizations/$id': typeof AuthenticatedOrganizationsIdRoute
  '/_authenticated/roadmap/$id': typeof AuthenticatedRoadmapIdRoute
  '/feedbacks/$campaignType/$campaignId': typeof FeedbacksCampaignTypeCampaignIdRoute
  '/_authenticated/campaigns/': typeof AuthenticatedCampaignsIndexRoute
  '/_authenticated/ideas/': typeof AuthenticatedIdeasIndexRoute
  '/_authenticated/knowledge-base/': typeof AuthenticatedKnowledgeBaseIndexRoute
  '/_authenticated/organizations/': typeof AuthenticatedOrganizationsIndexRoute
  '/_authenticated/profile/': typeof AuthenticatedProfileIndexRoute
  '/_authenticated/roadmap/': typeof AuthenticatedRoadmapIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accept-invitation'
    | '/onboarding'
    | '/register'
    | '/login'
    | '/campaigns/$campaignId'
    | '/organizations/$id'
    | '/roadmap/$id'
    | '/feedbacks/$campaignType/$campaignId'
    | '/campaigns'
    | '/ideas'
    | '/knowledge-base'
    | '/organizations'
    | '/profile'
    | '/roadmap'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/accept-invitation'
    | '/onboarding'
    | '/register'
    | '/login'
    | '/campaigns/$campaignId'
    | '/organizations/$id'
    | '/roadmap/$id'
    | '/feedbacks/$campaignType/$campaignId'
    | '/campaigns'
    | '/ideas'
    | '/knowledge-base'
    | '/organizations'
    | '/profile'
    | '/roadmap'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/accept-invitation'
    | '/onboarding'
    | '/register'
    | '/login/'
    | '/_authenticated/campaigns/$campaignId'
    | '/_authenticated/organizations/$id'
    | '/_authenticated/roadmap/$id'
    | '/feedbacks/$campaignType/$campaignId'
    | '/_authenticated/campaigns/'
    | '/_authenticated/ideas/'
    | '/_authenticated/knowledge-base/'
    | '/_authenticated/organizations/'
    | '/_authenticated/profile/'
    | '/_authenticated/roadmap/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  AcceptInvitationRoute: typeof AcceptInvitationRoute
  OnboardingRoute: typeof OnboardingRoute
  RegisterRoute: typeof RegisterRoute
  LoginIndexRoute: typeof LoginIndexRoute
  FeedbacksCampaignTypeCampaignIdRoute: typeof FeedbacksCampaignTypeCampaignIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invitation': {
      id: '/accept-invitation'
      path: '/accept-invitation'
      fullPath: '/accept-invitation'
      preLoaderRoute: typeof AcceptInvitationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/roadmap/': {
      id: '/_authenticated/roadmap/'
      path: '/roadmap'
      fullPath: '/roadmap'
      preLoaderRoute: typeof AuthenticatedRoadmapIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/': {
      id: '/_authenticated/profile/'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthenticatedProfileIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/organizations/': {
      id: '/_authenticated/organizations/'
      path: '/organizations'
      fullPath: '/organizations'
      preLoaderRoute: typeof AuthenticatedOrganizationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/knowledge-base/': {
      id: '/_authenticated/knowledge-base/'
      path: '/knowledge-base'
      fullPath: '/knowledge-base'
      preLoaderRoute: typeof AuthenticatedKnowledgeBaseIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ideas/': {
      id: '/_authenticated/ideas/'
      path: '/ideas'
      fullPath: '/ideas'
      preLoaderRoute: typeof AuthenticatedIdeasIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/campaigns/': {
      id: '/_authenticated/campaigns/'
      path: '/campaigns'
      fullPath: '/campaigns'
      preLoaderRoute: typeof AuthenticatedCampaignsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/feedbacks/$campaignType/$campaignId': {
      id: '/feedbacks/$campaignType/$campaignId'
      path: '/feedbacks/$campaignType/$campaignId'
      fullPath: '/feedbacks/$campaignType/$campaignId'
      preLoaderRoute: typeof FeedbacksCampaignTypeCampaignIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/roadmap/$id': {
      id: '/_authenticated/roadmap/$id'
      path: '/roadmap/$id'
      fullPath: '/roadmap/$id'
      preLoaderRoute: typeof AuthenticatedRoadmapIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/organizations/$id': {
      id: '/_authenticated/organizations/$id'
      path: '/organizations/$id'
      fullPath: '/organizations/$id'
      preLoaderRoute: typeof AuthenticatedOrganizationsIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/campaigns/$campaignId': {
      id: '/_authenticated/campaigns/$campaignId'
      path: '/campaigns/$campaignId'
      fullPath: '/campaigns/$campaignId'
      preLoaderRoute: typeof AuthenticatedCampaignsCampaignIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedCampaignsCampaignIdRoute: typeof AuthenticatedCampaignsCampaignIdRoute
  AuthenticatedOrganizationsIdRoute: typeof AuthenticatedOrganizationsIdRoute
  AuthenticatedRoadmapIdRoute: typeof AuthenticatedRoadmapIdRoute
  AuthenticatedCampaignsIndexRoute: typeof AuthenticatedCampaignsIndexRoute
  AuthenticatedIdeasIndexRoute: typeof AuthenticatedIdeasIndexRoute
  AuthenticatedKnowledgeBaseIndexRoute: typeof AuthenticatedKnowledgeBaseIndexRoute
  AuthenticatedOrganizationsIndexRoute: typeof AuthenticatedOrganizationsIndexRoute
  AuthenticatedProfileIndexRoute: typeof AuthenticatedProfileIndexRoute
  AuthenticatedRoadmapIndexRoute: typeof AuthenticatedRoadmapIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedCampaignsCampaignIdRoute: AuthenticatedCampaignsCampaignIdRoute,
  AuthenticatedOrganizationsIdRoute: AuthenticatedOrganizationsIdRoute,
  AuthenticatedRoadmapIdRoute: AuthenticatedRoadmapIdRoute,
  AuthenticatedCampaignsIndexRoute: AuthenticatedCampaignsIndexRoute,
  AuthenticatedIdeasIndexRoute: AuthenticatedIdeasIndexRoute,
  AuthenticatedKnowledgeBaseIndexRoute: AuthenticatedKnowledgeBaseIndexRoute,
  AuthenticatedOrganizationsIndexRoute: AuthenticatedOrganizationsIndexRoute,
  AuthenticatedProfileIndexRoute: AuthenticatedProfileIndexRoute,
  AuthenticatedRoadmapIndexRoute: AuthenticatedRoadmapIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  AcceptInvitationRoute: AcceptInvitationRoute,
  OnboardingRoute: OnboardingRoute,
  RegisterRoute: RegisterRoute,
  LoginIndexRoute: LoginIndexRoute,
  FeedbacksCampaignTypeCampaignIdRoute: FeedbacksCampaignTypeCampaignIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
